import axios from 'axios'
import Element from 'element-ui'
import router from './router'
import store from './store'


// axios.defaults.baseURL = "http://localhost:12350"
axios.defaults.baseURL = 'http://hr.borui-group.com:12350/'

// 前置拦截
axios.interceptors.request.use(config => {
    if (localStorage.getItem("token") != null && localStorage.getItem("token") != "") {
        config.headers['Authorization'] = localStorage.getItem("token");
    }
    return config
})

axios.interceptors.response.use(response => {
        let res = response.data;
        Element.Dialog.props.closeOnClickModal.default = false
        if (res.code   === 200) {
            return response
        } else {

            Element.Message.error(response.data.msg, {duration: 3 * 1000})

            return Promise.reject(response.data.msg)
        }
    },
    error => {
        if (error.response.status === 500) {
            error.message = error.response.data.message
            if (error.message.indexOf("请重新登录") >= 0) {
                router.push('/login');
            }
        } else if (error.response.data) {
            error.message = error.response.data.msg
        }

        if (error.response.status === 401) {
            store.commit("REMOVE_INFO")
            router.push("/login")
        }

        Element.Message.error(error.message, {duration: 3 * 1000})
        return Promise.reject(error)
    }
)